import React, { useEffect, useState } from 'react'

const useMobile = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [isMobilePortrait, setIsMobilePortrait] = useState(false);
    
    useEffect(() => {
        const checkMobile = () => {
            const mobile = typeof window !== 'undefined' ? window.innerWidth <= 600 : false;
            setIsMobile(mobile);
            setIsMobilePortrait(mobile && window.innerHeight > window.innerWidth);
        };
        
        checkMobile(); // Initial check
        window.addEventListener('resize', checkMobile);
        
        return () => window.removeEventListener('resize', checkMobile);
    }, []); // Empty dependency array is fine now as we don't use external values
    
    return {isMobile, isMobilePortrait};
}

export default useMobile